var _circle, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivacyLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 31,
    r: 31,
    fill: "#C8C7CF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3186_78046",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 14,
    width: 34,
    height: 34
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 34,
    height: 34,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3186_78046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0862 32.4174L32.0279 39.3591C32.3112 39.6424 32.447 39.973 32.4352 40.3508C32.4234 40.7286 32.2758 41.0591 31.9924 41.3424C31.7091 41.6022 31.3786 41.7379 31.0008 41.7497C30.623 41.7615 30.2924 41.6258 30.0091 41.3424L20.6591 31.9924C20.5174 31.8508 20.4171 31.6973 20.3581 31.532C20.299 31.3668 20.2695 31.1897 20.2695 31.0008C20.2695 30.8119 20.299 30.6348 20.3581 30.4695C20.4171 30.3043 20.5174 30.1508 20.6591 30.0091L30.0091 20.6591C30.2688 20.3994 30.5935 20.2695 30.9831 20.2695C31.3727 20.2695 31.7091 20.3994 31.9924 20.6591C32.2758 20.9424 32.4174 21.2789 32.4174 21.6685C32.4174 22.0581 32.2758 22.3945 31.9924 22.6779L25.0862 29.5841H40.9174C41.3188 29.5841 41.6553 29.7199 41.9268 29.9914C42.1984 30.2629 42.3341 30.5994 42.3341 31.0008C42.3341 31.4022 42.1984 31.7386 41.9268 32.0102C41.6553 32.2817 41.3188 32.4174 40.9174 32.4174H25.0862Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyLeftArrow);
export default __webpack_public_path__ + "static/media/privacy_left_arrow.9916ccae400d875592613754e6618d21.svg";
export { ForwardRef as ReactComponent };